<ng-container [ngSwitch]="viewLine.type">

    <div *ngSwitchCase="'calculation'" class="calculation line row">
        <!-- General info -->
        <!-- <input-cell #cell class="cell code" [column]="columns | prop: 'code'" [class.hidden]="columns | prop: 'code.hidden'" [rowIndex]="index" [selection]="selection"></input-cell> -->
        <tags-cell #cell class="cell code"
            [class.stale]="_staleProperties$ | async | stale: ['comment.type', 'comment.text']" [value]="_lineTags"
            [column]="columns | prop: 'code'" [class.hidden]="columns | prop: 'code.hidden'" [rowIndex]="index"
            [selection]="selection" (selectionChange)="_handleSelectionChange($event)"
            (onFocus)="_handleShowCommentModal()" (selectAbove)="_handleSelectAbove($event)"
            (selectRight)="_handleSelectRight($event)" (selectBelow)="_handleSelectBelow($event)"
            (selectLeft)="_handleSelectLeft($event)">
        </tags-cell>

        <input-cell #cell class="cell description" [class.stale]="_staleProperties$ | async | stale: 'description'"
            [class.warn]="warnings | fieldWarning: 0" type="text" [selectOnFocus]="false"
            (valueChange)="_setPropertyUndo('description', $event)" [value]="line.description"
            [title]="line.description" [column]="columns | prop: 'description'"
            [class.hidden]="columns | prop: 'description.hidden'" [rowIndex]="index" [selection]="selection"
            (selectionChange)="_handleSelectionChange($event)" (selectAbove)="_handleSelectAbove($event)"
            (selectRight)="_handleSelectRight($event)" (selectBelow)="_handleSelectBelow($event)"
            (selectLeft)="_handleSelectLeft($event)">
        </input-cell>

        <input-cell #cell class="cell quantity" [class.stale]="_staleProperties$ | async | stale: 'quantity'"
            [class.warn]="warnings | fieldWarning: 1" type="number" (valueChange)="_setPropertyUndo('quantity', $event)"
            [value]="line.quantity" [column]="columns | prop: 'quantity'"
            [class.hidden]="columns | prop: 'quantity.hidden'" [selection]="selection"
            (selectionChange)="_handleSelectionChange($event)" (selectAbove)="_handleSelectAbove($event)"
            (selectRight)="_handleSelectRight($event)" (selectBelow)="_handleSelectBelow($event)"
            (selectLeft)="_handleSelectLeft($event)"></input-cell>

        <!-- Unit -->
        <dropdown-cell #cell class="cell unit" [class.stale]="_staleProperties$ | async | stale: 'unit'"
            [items]="allowedUnits" (valueChange)="_setPropertyUndo('unit', $event)" [value]="line.unit"
            [column]="columns['unit']" [class.hidden]="columns['unit'].hidden" [rowIndex]="index"
            [selection]="selection" (selectionChange)="_handleSelectionChange($event)"
            (selectAbove)="_handleSelectAbove($event)" (selectRight)="_handleSelectRight($event)"
            (selectBelow)="_handleSelectBelow($event)" (selectLeft)="_handleSelectLeft($event)"></dropdown-cell>

        <!-- Hours -->
        <input-cell #cell class="cell hour-norm"
            [class.stale]="_staleProperties$ | async | stale: ['hours.norm', 'rate']"
            [class.warn]="warnings | fieldWarning: 2" (valueChange)="_setValueSetUndo(line.hours, 'norm', $event)"
            [value]="line.hours.norm" [column]="columns['hour-norm']" [class.hidden]="columns['hour-norm'].hidden"
            [rowIndex]="index" [selection]="selection" (selectionChange)="_handleSelectionChange($event)"
            (selectAbove)="_handleSelectAbove($event)" (selectRight)="_handleSelectRight($event)"
            (selectBelow)="_handleSelectBelow($event)" (selectLeft)="_handleSelectLeft($event)"></input-cell>

        <input-cell #cell class="cell hour-net" [value]="aggregation?.['hours']?.hours" [column]="columns['hour-net']"
            [class.hidden]="columns['hour-net'].hidden" [rowIndex]="index" [selection]="selection"></input-cell>

        <currency-input-cell #cell class="cell wage-net" [value]="aggregation?.['hours']?.net"
            [column]="columns['wage-net']" [class.hidden]="columns['wage-net'].hidden" [rowIndex]="index"
            [selection]="selection"></currency-input-cell>

        <input-cell #cell class="cell hour-percent" [class.stale]="_staleProperties$ | async | stale: 'hours.percent'"
            type="percent" (valueChange)="_setValueSetUndo(line.hours, 'percent', $event)" [value]="line.hours.percent"
            [default]="['sptnN', 'spt'].includes(line.unit) ? undefined : percentages?.hours"
            [column]="columns['hour-percent']" [class.hidden]="columns | prop: 'hour-percent.hidden'" [rowIndex]="index"
            [selection]="selection" (selectionChange)="_handleSelectionChange($event)"
            (selectAbove)="_handleSelectAbove($event)" (selectRight)="_handleSelectRight($event)"
            (selectBelow)="_handleSelectBelow($event)" (selectLeft)="_handleSelectLeft($event)"></input-cell>

        <currency-input-cell #cell class="cell hour-gross" [value]="aggregation?.['hours']?.gross"
            [column]="columns['hour-gross']" [class.hidden]="columns['hour-gross'].hidden" [rowIndex]="index"
            [selection]="selection"></currency-input-cell>

        <!-- Materials -->
        <currency-input-cell #cell class="cell material-norm"
            [class.stale]="_staleProperties$ | async | stale: ['material.norm', 'rate']"
            [class.warn]="warnings | fieldWarning: 2" (valueChange)="_setValueSetUndo(line.material, 'norm', $event)"
            [value]="line.material.norm" [column]="columns['material-norm']"
            [class.hidden]="columns['material-norm'].hidden" [rowIndex]="index" [selection]="selection"
            (selectionChange)="_handleSelectionChange($event)" (selectAbove)="_handleSelectAbove($event)"
            (selectRight)="_handleSelectRight($event)" (selectBelow)="_handleSelectBelow($event)"
            (selectLeft)="_handleSelectLeft($event)"></currency-input-cell>

        <currency-input-cell #cell class="cell material-net" [value]="aggregation?.['material']?.net"
            [column]="columns['material-net']" [class.hidden]="columns['material-net'].hidden" [rowIndex]="index"
            [selection]="selection"></currency-input-cell>

        <input-cell #cell class="cell material-percent"
            [class.stale]="_staleProperties$ | async | stale: 'material.percent'" type="percent"
            (valueChange)="_setValueSetUndo(line.material, 'percent', $event)" [value]="line.material.percent"
            [default]="['sptnN', 'spt'].includes(line.unit) ? undefined : percentages?.material"
            [column]="columns['material-percent']" [class.hidden]="columns | prop: 'material-percent.hidden'"
            [rowIndex]="index" [selection]="selection" (selectionChange)="_handleSelectionChange($event)"
            (selectAbove)="_handleSelectAbove($event)" (selectRight)="_handleSelectRight($event)"
            (selectBelow)="_handleSelectBelow($event)" (selectLeft)="_handleSelectLeft($event)"></input-cell>

        <currency-input-cell #cell class="cell material-gross" [value]="aggregation?.['material']?.gross"
            [column]="columns['material-gross']" [class.hidden]="columns['material-gross'].hidden" [rowIndex]="index"
            [selection]="selection"></currency-input-cell>

        <!-- Equipment -->
        <currency-input-cell #cell class="cell equipment-norm"
            [class.stale]="_staleProperties$ | async | stale: ['equipment.norm', 'rate']"
            [class.warn]="warnings | fieldWarning: 2" (valueChange)="_setValueSetUndo(line.equipment, 'norm', $event)"
            [value]="line.equipment.norm" [column]="columns['equipment-norm']"
            [class.hidden]="columns['equipment-norm'].hidden" [rowIndex]="index" [selection]="selection"
            (selectionChange)="_handleSelectionChange($event)" (selectAbove)="_handleSelectAbove($event)"
            (selectRight)="_handleSelectRight($event)" (selectBelow)="_handleSelectBelow($event)"
            (selectLeft)="_handleSelectLeft($event)"></currency-input-cell>

        <currency-input-cell #cell class="cell equipment-net" [value]="aggregation?.['equipment']?.net"
            [column]="columns['equipment-net']" [class.hidden]="columns['equipment-net'].hidden" [rowIndex]="index"
            [selection]="selection"></currency-input-cell>

        <input-cell #cell class="cell equipment-percent"
            [class.stale]="_staleProperties$ | async | stale: 'equipment.percent'" type="percent"
            (valueChange)="_setValueSetUndo(line.equipment, 'percent', $event)" [value]="line.equipment.percent"
            [default]="['sptnN', 'spt'].includes(line.unit) ? undefined : percentages?.equipment"
            [column]="columns['equipment-percent']" [class.hidden]="columns | prop: 'equipment-percent.hidden'"
            [rowIndex]="index" [selection]="selection" (selectionChange)="_handleSelectionChange($event)"
            (selectAbove)="_handleSelectAbove($event)" (selectRight)="_handleSelectRight($event)"
            (selectBelow)="_handleSelectBelow($event)" (selectLeft)="_handleSelectLeft($event)"></input-cell>

        <currency-input-cell #cell class="cell equipment-gross" [value]="aggregation?.['equipment']?.gross"
            [column]="columns['equipment-gross']" [class.hidden]="columns['equipment-gross'].hidden" [rowIndex]="index"
            [selection]="selection"></currency-input-cell>

        <!-- Subcontracting -->
        <currency-input-cell #cell class="cell subcontracting-norm"
            [class.stale]="_staleProperties$ | async | stale: ['subcontracting.norm', 'rate']"
            [class.warn]="warnings | fieldWarning: 2"
            (valueChange)="_setValueSetUndo(line.subcontracting, 'norm', $event)" [value]="line.subcontracting.norm"
            [column]="columns['subcontracting-norm']" [class.hidden]="columns['subcontracting-norm'].hidden"
            [rowIndex]="index" [selection]="selection" (selectionChange)="_handleSelectionChange($event)"
            (selectAbove)="_handleSelectAbove($event)" (selectRight)="_handleSelectRight($event)"
            (selectBelow)="_handleSelectBelow($event)" (selectLeft)="_handleSelectLeft($event)"></currency-input-cell>

        <currency-input-cell #cell class="cell subcontracting-net" [value]="aggregation?.['subcontracting']?.net"
            [column]="columns['subcontracting-net']" [class.hidden]="columns['subcontracting-net'].hidden"
            [rowIndex]="index" [selection]="selection"></currency-input-cell>

        <input-cell #cell class="cell subcontracting-percent"
            [class.stale]="_staleProperties$ | async | stale: 'subcontracting.percent'" type="percent"
            (valueChange)="_setValueSetUndo(line.subcontracting, 'percent', $event)"
            [value]="line.subcontracting.percent"
            [default]="['sptnN', 'spt'].includes(line.unit) ? undefined : percentages?.subcontracting" [column]="columns['subcontracting-percent']"
            [class.hidden]="columns | prop: 'subcontracting-percent.hidden'" [rowIndex]="index" [selection]="selection"
            (selectionChange)="_handleSelectionChange($event)" (selectAbove)="_handleSelectAbove($event)"
            (selectRight)="_handleSelectRight($event)" (selectBelow)="_handleSelectBelow($event)"
            (selectLeft)="_handleSelectLeft($event)">
        </input-cell>

        <currency-input-cell #cell class="cell subcontracting-gross" [value]="aggregation?.['subcontracting']?.gross"
            [column]="columns['subcontracting-gross']" [class.hidden]="columns['subcontracting-gross'].hidden"
            [rowIndex]="index" [selection]="selection"></currency-input-cell>


        <!-- Totals -->
        <currency-input-cell #cell class="cell norm total" [value]="aggregation?.['all']?.unitPrice"
            [column]="columns['total-norm']" [class.hidden]="columns['total-norm'].hidden" [rowIndex]="index"
            [selection]="selection"></currency-input-cell>
        <currency-input-cell #cell class="cell net total" [value]="aggregation?.['all']?.net"
            [column]="columns['total-net']" [class.hidden]="columns['total-net'].hidden" [rowIndex]="index"
            [selection]="selection"></currency-input-cell>
        <currency-input-cell #cell class="cell gross total" [value]="aggregation?.['all']?.gross"
            [column]="columns['total-gross']" [class.hidden]="columns['total-gross'].hidden" [rowIndex]="index"
            [selection]="selection"></currency-input-cell>
    </div>

    <div *ngSwitchCase="'text'" class="text line row">
        <!-- General info -->
        <tags-cell #cell class="cell code" [value]="_lineTags" [column]="columns['code']"
            [class.hidden]="columns['code'].hidden" [rowIndex]="index" [selection]="selection"
            (selectionChange)="_handleSelectionChange($event)" (onFocus)="_handleShowCommentModal()"></tags-cell>

        <multi-line-text-input-cell #cell class="cell description"
            [class.stale]="_staleProperties$ | async | stale: 'description'" [selectOnFocus]="false"
            (valueChange)="_setPropertyUndo('description', $event)" [value]="line.description"
            (input)="_updateSelectionHighlight()" [column]="columns['description']"
            [class.hidden]="columns['description'].hidden" [rowIndex]="index" [selection]="selection"
            (selectionChange)="_handleSelectionChange($event)"></multi-line-text-input-cell>

        <!-- Quantity and unit -->
        <input-cell #cell class="cell quantity" [class.stale]="_staleProperties$ | async | stale: 'quantity'"
            type="number" (valueChange)="_setPropertyUndo('quantity', $event)" [(value)]="line.quantity"
            [column]="columns['quantity']" [class.hidden]="columns['quantity'].hidden" [rowIndex]="index"
            [selection]="selection" (selectionChange)="_handleSelectionChange($event)"></input-cell>

        <dropdown-cell #cell class="cell unit" [class.stale]="_staleProperties$ | async | stale: 'unit'"
            [items]="allowedUnits" [nullable]="true" (valueChange)="_setPropertyUndo('unit', $event)"
            [(value)]="line.unit" [column]="columns['unit']" [class.hidden]="columns['unit'].hidden" [rowIndex]="index"
            [selection]="selection" (selectionChange)="_handleSelectionChange($event)"
            (selectAbove)="_handleSelectAbove($event)" (selectRight)="_handleSelectRight($event)"
            (selectBelow)="_handleSelectBelow($event)" (selectLeft)="_handleSelectLeft($event)"></dropdown-cell>

        <!-- Hours -->
        <div class="cell hour-norm" [class.hidden]="columns['hour-norm'].hidden"
            [style.width]="columns['hour-norm'].width | percent:'1.0-6'"></div>
        <div class="cell hour-net" [class.hidden]="columns['hour-net'].hidden"
            [style.width]="columns['hour-net'].width | percent:'1.0-6'"></div>
        <div class="cell wage-net" [class.hidden]="columns['wage-net'].hidden"
            [style.width]="columns['wage-net'].width | percent:'1.0-6'"></div>
        <div class="cell hour-percent" [class.hidden]="columns['hour-percent'].hidden"
            [style.width]="columns['hour-percent'].width | percent:'1.0-6'"></div>
        <div class="cell hour-gross" [class.hidden]="columns['hour-gross'].hidden"
            [style.width]="columns['hour-gross'].width | percent:'1.0-6'"></div>

        <!-- Materials -->
        <div class="cell material-norm" [class.hidden]="columns['material-norm'].hidden"
            [style.width]="columns['material-norm'].width | percent:'1.0-6'"></div>
        <div class="cell material-net" [class.hidden]="columns['material-net'].hidden"
            [style.width]="columns['material-net'].width | percent:'1.0-6'"></div>
        <div class="cell material-percent" [class.hidden]="columns['material-percent'].hidden"
            [style.width]="columns['material-percent'].width | percent:'1.0-6'"></div>
        <div class="cell material-gross" [class.hidden]="columns['material-gross'].hidden"
            [style.width]="columns['material-gross'].width | percent:'1.0-6'"></div>

        <!-- Equipment -->
        <div class="cell equipment-norm" [class.hidden]="columns['equipment-norm'].hidden"
            [style.width]="columns['equipment-norm'].width | percent:'1.0-6'"></div>
        <div class="cell equipment-net" [class.hidden]="columns['equipment-net'].hidden"
            [style.width]="columns['equipment-net'].width | percent:'1.0-6'"></div>
        <div class="cell equipment-percent" [class.hidden]="columns['equipment-percent'].hidden"
            [style.width]="columns['equipment-percent'].width | percent:'1.0-6'"></div>
        <div class="cell equipment-gross" [class.hidden]="columns['equipment-gross'].hidden"
            [style.width]="columns['equipment-gross'].width | percent:'1.0-6'"></div>

        <!-- Subcontracting -->
        <div class="cell subcontracting-norm" [class.hidden]="columns['subcontracting-norm'].hidden"
            [style.width]="columns['subcontracting-norm'].width | percent:'1.0-6'"></div>
        <div class="cell subcontracting-net" [class.hidden]="columns['subcontracting-net'].hidden"
            [style.width]="columns['subcontracting-net'].width | percent:'1.0-6'"></div>
        <div class="cell subcontracting-percent" [class.hidden]="columns['subcontracting-percent'].hidden"
            [style.width]="columns['subcontracting-percent'].width | percent:'1.0-6'"></div>
        <div class="cell subcontracting-gross" [class.hidden]="columns['subcontracting-gross'].hidden"
            [style.width]="columns['subcontracting-gross'].width | percent:'1.0-6'"></div>

        <!-- Totals -->
        <div class="cell norm total" [class.hidden]="columns['total-norm'].hidden"
            [style.width]="columns['total-norm'].width | percent:'1.0-6'"></div>
        <div class="cell net total" [class.hidden]="columns['total-net'].hidden"
            [style.width]="columns['total-net'].width | percent:'1.0-6'"></div>
        <div class="cell gross total" [class.hidden]="columns['total-gross'].hidden"
            [style.width]="columns['total-gross'].width | percent:'1.0-6'"></div>
    </div>

    <div *ngIf="viewLine.type === 'tailAmount' || viewLine.type === 'tailPercentage'" class="calc line row">

        <div class="cell spacer" [style.width]="columns['spacer'].width | percent:'1.0-6'"></div>

        <!-- Type -->
        <dropdown-cell #cell class="cell type" [value]="viewLine | transform: _getType"
            (valueChange)="_HandleChangeType($event)" [items]="_types" [column]="columns['type']" [rowIndex]="index"
            [selection]="selection" (selectionChange)="_handleSelectionChange($event)"
            (selectLeft)="_handleSelectLeft()" (selectRight)="_handleSelectRight()" (selectAbove)="_handleSelectAbove()"
            (selectBelow)="_handleSelectBelow()"></dropdown-cell>

        <!-- Description -->
        <input-cell #cell class="cell tail description" type="text"
            (valueChange)="_setPropertyUndo('description', $event)" [value]="line.description"
            [column]="columns['description']" [rowIndex]="index" [selection]="selection"
            (selectionChange)="_handleSelectionChange($event)" (selectLeft)="_handleSelectLeft()"
            (selectRight)="_handleSelectRight()" (selectAbove)="_handleSelectAbove()"
            (selectBelow)="_handleSelectBelow()"></input-cell>

        <ng-container *ngIf="viewLine.type === 'tailAmount'; else percent">
            <!-- Amount (Currency) -->
            <currency-input-cell #cell class="cell amount" (valueChange)="_setPropertyUndo('amount', $event)"
                [value]="line.amount" [column]="columns['amount']" [rowIndex]="index" [selection]="selection"
                (selectionChange)="_handleSelectionChange($event)" (selectLeft)="_handleSelectLeft()"
                (selectRight)="_handleSelectRight()" (selectAbove)="_handleSelectAbove()"
                (selectBelow)="_handleSelectBelow()"></currency-input-cell>
        </ng-container>
        <ng-template #percent>
            <!-- Amount (Percent) -->
            <input-cell #cell class="cell tail amount" type="percent"
                (valueChange)="_setPropertyUndo('percent', $event)" [value]="line.percent" [column]="columns['amount']"
                [rowIndex]="index" [selection]="selection" (selectionChange)="_handleSelectionChange($event)"
                (selectLeft)="_handleSelectLeft()" (selectRight)="_handleSelectRight()"
                (selectAbove)="_handleSelectAbove()" (selectBelow)="_handleSelectBelow()"></input-cell>
        </ng-template>

        <!-- Total -->
        <currency-input-cell #cell class="cell total" [column]="columns['total']" [rowIndex]="index"
            [value]="aggregation?.all.gross" [selection]="selection" (selectionChange)="_handleSelectionChange($event)"
            (selectLeft)="_handleSelectLeft()" (selectRight)="_handleSelectRight()" (selectAbove)="_handleSelectAbove()"
            (selectBelow)="_handleSelectBelow()"></currency-input-cell>
    </div>

    <div *ngSwitchCase="'tailText'" class="text line row">

        <div class="cell spacer" [style.width]="columns['spacer'].width | percent:'1.0-6'"></div>

        <!-- Type -->
        <dropdown-cell #cell class="cell type" [value]="viewLine | transform: _getType"
            (valueChange)="_HandleChangeType($event)" [items]="_types" [column]="columns['type']" [rowIndex]="index"
            [selection]="selection" (selectionChange)="_handleSelectionChange($event)"
            (selectLeft)="_handleSelectLeft()" (selectRight)="_handleSelectRight()" (selectAbove)="_handleSelectAbove()"
            (selectBelow)="_handleSelectBelow()"></dropdown-cell>

        <!-- Description -->
        <!-- <input-cell #cell class="cell description" type="text" (valueChange)="_setPropertyUndo('description', $event)"
            [value]="line.description" [column]="columns['description']"
            [rowIndex]="index" [selection]="selection" (selectionChange)="_handleSelectionChange($event)"
            (selectLeft)="_handleSelectLeft()" (selectRight)="_handleSelectRight()" (selectAbove)="_handleSelectAbove()"
            (selectBelow)="_handleSelectBelow()"></input-cell> -->
        <multi-line-text-input-cell #cell class="cell description" (input)="_updateSelectionHighlight()"
            (valueChange)="_setPropertyUndo('description', $event)" [value]="line.description"
            [column]="columns['description']" [rowIndex]="index" [selection]="selection"
            (selectionChange)="_handleSelectionChange($event)" (selectLeft)="_handleSelectLeft()"
            (selectRight)="_handleSelectRight()" (selectAbove)="_handleSelectAbove()"
            (selectBelow)="_handleSelectBelow()"></multi-line-text-input-cell>

        <!-- Amount -->
        <!-- <div class="cell" [style.width]="columns['amount'].width | percent:'1.0-6'"></div> -->
        <text-cell #cell class="cell" [column]="columns['amount']" [rowIndex]="index" [selection]="selection"
            (selectionChange)="_handleSelectionChange($event)"></text-cell>

        <!-- Total -->
        <div class="cell" [style.width]="columns['total'].width | percent:'1.0-6'"></div>
    </div>

</ng-container>
<ng-template #debug>

    <input-cell *ngIf="!!line.hours" #cell class="cell hour-percent"
        [class.stale]="_staleProperties$ | async | stale: 'hours.percent'" type="percent" [value]="line.hours.percent"
        [column]="columns['hour-percent']" [class.hidden]="columns | prop: 'hour-percent.hidden'" [rowIndex]="index"
        [selection]="selection" (selectionChange)="_handleSelectionChange($event)"></input-cell>
</ng-template>